export default class MapsEventsRmc{
     
    constructor(element) {
        this._wrapper = element;
        this._map = this._wrapper.querySelector('.js-maps-events-rmc-map');
        this._blocks = this._wrapper.querySelectorAll('.js-maps-events-rmc-block');
        this._closes = this._wrapper.querySelectorAll('.js-maps-events-rmc-close');
        this._geoloc = this._wrapper.querySelector('.js-maps-events-rmc-geoloc');
        this.markers = [];
        this._markersData = [
            {
                name: 'Paris',
                coords: [48.8566, 2.3522],
                description: 'Capitale de la France'
            },
            {
                name: 'Lyon',
                coords: [45.75, 4.85],
                description: 'Ville des lumières'
            },
            {
                name: 'Marseille',
                coords: [43.2965, 5.3698],
                description: 'Ville portuaire de la Méditerranée'
            }
        ];
        this.icon = L.icon({
            iconUrl: template_directory+'/dist/images/svg/marker.svg',

            iconSize:     [25, 33],
            iconAnchor:   [12, 33],
        });

        this.icon_yellow = L.icon({
            iconUrl: template_directory+'/dist/images/svg/marker_clicked.svg',

            iconSize:     [25, 33],
            iconAnchor:   [12, 33],
        });
        this.initMap();
        this.bindEvents();
    }
    
    bindEvents(){
        app.nodesEventListener('click', this._closes, (el,n,e) => {
            this.markers[n].setIcon(this.icon);
            this._blocks[n].classList.add('d-none');
        });
        this._geoloc.addEventListener('click', () => {
            if (!navigator.geolocation) return;

            navigator.geolocation.getCurrentPosition((position) => {
                const userLatLng = [position.coords.latitude, position.coords.longitude];

                L.circleMarker(userLatLng, {
                    radius: 6,
                    color: '#007BFF',
                    fillColor: '#007BFF',
                    fillOpacity: 0.8
                })
                    .addTo(this.leaflet)
                    .bindPopup('Vous êtes ici')
                    .openPopup();

                this.leaflet.setView(userLatLng, 8);
            });
        });
    }


    initMap() {

        this.leaflet = L.map(this._map).setView([46.6031, 1.8883], 6);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            // attribution: '&copy; OpenStreetMap contributors'
        }).addTo(this.leaflet);

        map_markers.forEach((point,n) => {
            const marker = L.marker(point.coords, {icon: this.icon}).addTo(this.leaflet);
            
            marker.on('click', () => {
                app.nodesAddClass(this._blocks,'d-none');
                this.markers.forEach((item) => {
                    item.setIcon(this.icon);
                    this._blocks[n].classList.remove('d-none');
                })
               marker.setIcon(this.icon_yellow); 
            });
            
            this.markers.push(marker);
        });
    }
    
}